import gql from 'graphql-tag';

export default gql`
mutation deleteProjectTagsByProjectId($projectId: Int!) {
  delete_projects_tags(where: {project_id: {_eq: $projectId}}) {
    affected_rows
  }
}
`;
